(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HospitalizationDischargeToDialogController', HospitalizationDischargeToDialogController);

    HospitalizationDischargeToDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HospitalizationDischargeTo', 'Hospitalization', 'Corporation'];

    function HospitalizationDischargeToDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HospitalizationDischargeTo, Hospitalization, Corporation) {
        var vm = this;

        vm.hospitalizationDischargeTo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.hospitalizationDischargeTo.id !== null) {
                HospitalizationDischargeTo.update(vm.hospitalizationDischargeTo, onSaveSuccess, onSaveError);
            } else {
                HospitalizationDischargeTo.save(vm.hospitalizationDischargeTo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:hospitalizationDischargeToUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
